module.exports = __webpack_public_path__ + "static/phone1-14a5f4cc9773a46737f6c1429b81705c.png";